import React from 'react'
import Header from '../../Components/Header/Header'
import BannerGlobal from '../../Components/Banner/BannerGlobal'
import Footer from '../../Components/Footer/Footer'
import ContactComponent from '../../Components/ContactComponent/ContactComponent'
import TeamComponent from '../../Components/TeamComponent/TeamComponent'
import useDocumentTitle from '../../PageTitle'

const Team = () => {
  useDocumentTitle("Medical | Teams")
  return (
    <div>
        <Header/>
        <BannerGlobal/>
        <TeamComponent />
        <ContactComponent/>
        <Footer/>
    </div>
  )
}

export default Team